import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
} from "@mui/material";

// Validaciones con Yup
const schema = yup.object().shape({
  tipmannom: yup
    .string()
    .required("El nombre del tipo de mantenimiento es obligatorio"),
  tipmandes: yup
    .string()
    .max(255, "Máximo 255 caracteres"),
});

const MaintenanceTypesForm = ({
  open,
  handleClose,
  onSubmit,
  defaultValues = {},
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  // Resetear el formulario cuando cambian los valores o se abre el modal
  useEffect(() => {
    if (open) reset(defaultValues);
  }, [open, defaultValues, reset]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {defaultValues?.tipmanid
          ? "Editar Tipo de Mantenimiento"
          : "Crear Tipo de Mantenimiento"}
      </DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          {/* Nombre del tipo de mantenimiento */}
          <TextField
            label="Nombre del Tipo de Mantenimiento"
            fullWidth
            margin="normal"
            {...register("tipmannom")}
            error={!!errors.tipmannom}
            helperText={errors.tipmannom?.message}
          />

          {/* Descripción */}
          <TextField
            label="Descripción (opcional)"
            fullWidth
            margin="normal"
            {...register("tipmandes")}
            error={!!errors.tipmandes}
            helperText={errors.tipmandes?.message}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type="submit" variant="contained">
            {defaultValues?.tipmanid ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MaintenanceTypesForm;
